import * as React from 'react'
import { LayoutView, LayoutViewProps } from '@bestyled/primitives'

type LayoutProps = {
  x: number
  y: number
  height: number
  width: number
  size: number
  onLayout: (e: any) => void
}

const MeasureContext = React.createContext<LayoutProps>(null!)

export const useMeasure = () => React.useContext(MeasureContext)

export const MeasureProvider: React.FC<{}> = (props) => {
  const [state, setState] = React.useState({
    height: null!,
    width: null!,
    x: null!,
    y: null!,
    size: 0
  })

  const onLayout = React.useCallback((e) => {
    setState({
      ...e.nativeEvent.layout
    })
  }, [])

  const context = React.useMemo(() => ({ ...state, onLayout }), [
    state,
    onLayout
  ])

  return (
    <MeasureContext.Provider value={context}>
      {props.children}
    </MeasureContext.Provider>
  )
}

export const Measure: React.FC<Partial<LayoutViewProps>> = ({
  children,
  ...rest
}) => {
  const { onLayout } = useMeasure()

  return (
    <LayoutView onLayout={onLayout} {...rest}>
      {children}
    </LayoutView>
  )
}
